import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';
import * as actions from './redux/actions';
import { TEAM_MANAGER_TYPES } from './redux/constants';

export class OpportunityHeader extends Component {
  render() {
    const {
      isNewOpportunity,
      isCompleted,
      componentRef,
      handlePrintToggle,
      user: {
        firstName,
        lastName,
        teamManagerType,
      },
      opportunity: {
        isOverdue,
        overdueDays,
        callLogId,
        originateTeamLead: { fullName: teamLeadName = '' },
        salesAgent: { fullName },
        dateCreatedEst,
        status: { name },
      },
    } = this.props;

    let isIncompleteOverdue = !isCompleted && isOverdue;

    return (
      <div className="ac-op-header">
        <div className="title">
          <div>{isNewOpportunity ? 'New Coaching Opportunity' : callLogId ? `${callLogId} - ${fullName}` : `${fullName}`}</div>
          {!isNewOpportunity && (
            <ReactToPrint
              trigger={() => <button type="button" className="print-button">Print</button>}
              content={() => componentRef}
              onBeforeGetContent={() => {
                return new Promise((res) => {
                  handlePrintToggle(true, res);
                })
              }}
              onAfterPrint={() => {
                return new Promise((res) => {
                  handlePrintToggle(false, res);
                })
              }}
            />
          )}
        </div>
        {isNewOpportunity && (
          <div className="op-header__rest">
            <div className="op-header-row">
              <div className="common-label row-header">{TEAM_MANAGER_TYPES[teamManagerType]}</div>
              <div>{`${firstName} ${lastName}`}</div>
            </div>
          </div>
        )}
        { !isNewOpportunity && (
          <div className="op-header__rest">
            <div className="op-header-row">
              <div className="common-label row-header">{TEAM_MANAGER_TYPES[teamManagerType]}</div>
              <div>{`${firstName} ${lastName}`}</div>
            </div>
            <div className="op-header-row">
              <div className="common-label row-header">Date Created</div>
              <div>{dateCreatedEst}</div>
            </div>
            <div className="op-header-row">
              <div className="common-label row-header">Created By</div>
              <div>{ teamLeadName }</div>
            </div>
            <div className="op-header-row">
              <div className="common-label row-header">Status</div>
                <div>
                  <div className={isCompleted ? 'status-text__completed' : 'status-text__default'}>
                    { `${name}` }
                    {isIncompleteOverdue && (
                      <div>
                        <span className="overdue-dash">-</span>
                        <span className="overdue-text">
                          {`Overdue - ${overdueDays} day${overdueDays > 1 ? 's' : ''}`}
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

OpportunityHeader.propTypes = {
  isNewOpportunity: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  opportunity: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

OpportunityHeader.defaultProps = {
  opportunity: {
    salesAgent: {},
    status: {},
    originateTeamLead: {},
  },
  user: {},
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const defaultOpp = {
    salesAgent: {},
    status: {},
    originateTeamLead: {},
  };

  return {
    opportunity: ownProps.isNewOpportunity ? defaultOpp : state.agentCoaching.singleOpportunity,
    user: state.common.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunityHeader);



// WEBPACK FOOTER //
// ./src/features/agent-coaching/OpportunityHeader.js